"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const opexs_1 = require("@/store/ducks/opexs");
const opexs_2 = require("@/services/opexs");
function listOpexsUseCase() {
    return (dispatch) => {
        dispatch((0, opexs_1.getOpexsReducer)());
        (0, opexs_2.getOpexsService)()
            .then((opexs) => {
            dispatch((0, opexs_1.getOpexsSuccessReducer)(opexs));
        })
            .catch(() => {
            dispatch((0, opexs_1.getOpexsErrorReducer)());
        });
    };
}
exports.default = listOpexsUseCase;
